import ErrorBoundary from './error-boundary.component';

export default ErrorBoundary;
